import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";

import HomeSection from "../components/partials/home/home-section";
import InfoSection from "../components/partials/home/info-section";
import FeaturedCollection from "../components/partials/home/featured-collection";
import NewCollection from "../components/partials/home/new-collection";
import CategorySection from "../components/partials/home/category-section";
import BrandSection from "../components/partials/home/brand-section";
import BlogSection from '../components/partials/home/blog-section';
import SolutionsSection from "../components/partials/home/solutions-section";
import {solutions} from "../utils/data/solutions";
import Seo from "../components/common/Seo";
import useTranslation from "../utils/hooks/useTranslation";

function Home({featuredProducts, latestProducts, blog}) {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const featured = featuredProducts.list;
    const latest = latestProducts.list;

    useEffect(() => {
        let offset = document.querySelector('body').getBoundingClientRect().top + window.pageYOffset - 58;

        setTimeout(() => {
            window.scrollTo({top: offset, behavior: 'smooth'});
        }, 50);

    }, [])

    useEffect(() => {
        setLoading(featuredProducts.loading || latestProducts.loading);
    }, [featuredProducts.loading, latestProducts.loading])

    const seo = <Seo title={t("seo.home_title")} description={t("seo.home_description")}/>;

    if (featuredProducts.error) {
        return <>{seo}<div>{featuredProducts.error?.message}</div></>
    }

    return (
        <>
            {seo}
            <main className={`skeleton-body skel-shop-products ${loading ? '' : 'loaded'}`}>
                <h1 className="sr-only">{t("seo.home_title")}</h1>
                <HomeSection/>

                <div className="container">
                    <InfoSection/>
                </div>

                <FeaturedCollection products={featured} loading={featuredProducts.loading}/>

                <NewCollection products={latest} loading={latestProducts.loading}/>

                <div className="container">
                    <CategorySection/>
                </div>

                <BlogSection blog={blog.list} loading={blog.loading}/>

                <SolutionsSection solution={solutions}/>

                <div className="container">
                    <BrandSection/>

                    <hr className="mt-0 mb-0"/>
                </div>
            </main>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        featuredProducts: state.products.featured,
        latestProducts: state.products.latest,
        blog: state.blogs,
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
